









import { Component, Prop, Vue } from 'vue-property-decorator';
import Message from '../message';
import { CONFIRMED, NOT_CONFIRMED, MESSAGE } from './consts';

@Component({
  components: {
    Message,
  },
})
export default class Info extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isConfirmed!: boolean;

  message: string = MESSAGE;

  get confirmedText(): string {
    return this.isConfirmed ? CONFIRMED : NOT_CONFIRMED;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/settings/components/info/Info.vue